import { render, staticRenderFns } from "./AiMessage.vue?vue&type=template&id=4a449ff0&scoped=true"
import script from "./AiMessage.vue?vue&type=script&lang=js"
export * from "./AiMessage.vue?vue&type=script&lang=js"
import style0 from "./AiMessage.vue?vue&type=style&index=0&id=4a449ff0&prod&scoped=true&lang=css"
import style1 from "./AiMessage.vue?vue&type=style&index=1&id=4a449ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a449ff0",
  null
  
)

export default component.exports